import React from "react";
import { translateService } from "../../services/imports";

// a yyyy-MM-dd calendar date as dd.MM.yyyy - read as text, never through a
// Date, so no time zone moves it a day
const calendarDate = (value) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
  return m ? `${m[3]}.${m[2]}.${m[1]}` : value || null;
};

// the Georgian-script pair when either of it is present, else the Latin one;
// whichever names of the pair are present (an eID pair may be partial)
export const verifiedName = (v) => {
  const local = [v.firstNameLocal, v.lastNameLocal].filter(Boolean);
  if (local.length) return local.join(" ");
  const latin = [v.firstName, v.lastName].filter(Boolean);
  return latin.length ? latin.join(" ") : null;
};

// The identity signature-gateway verified for a signing (vsys
// verifiedSignatory): beside the sign-in name, never in its place - the
// method, the verified name, the personal number in full, and the document's
// details collapsed. Null shows nothing (a seal, a signing stored before).
// None of it ever goes into a URL, a log or an error report.
export default class VerifiedIdentity extends React.Component {
  state = { open: false };

  render() {
    const v = this.props.value;
    if (!v) return null;
    const t = (k, ...a) => translateService.t(`signings.verified.${k}`, ...a);
    const name = verifiedName(v);
    const details = [
      ["document", v.documentType],
      ["documentNumber", v.documentNumber],
      ["issuingCountry", v.issuingCountry],
      ["issueDate", calendarDate(v.issueDate)],
      ["expirationDate", calendarDate(v.expirationDate)],
      ["birthDate", calendarDate(v.birthDate)],
      ["nationality", v.nationality],
    ].filter(([, value]) => value);
    return (
      <div className="verified-identity">
        <span className="verified-identity__method">{t(v.authType) || v.authType}</span>
        {name && <span className="verified-identity__name">{name}</span>}
        {v.personalId && <span className="verified-identity__id">{t("personalId", v.personalId)}</span>}
        {details.length > 0 && (
          <React.Fragment>
            <button
              type="button"
              className="verified-identity__toggle"
              aria-expanded={this.state.open}
              onClick={() => this.setState((s) => ({ open: !s.open }))}
            >
              {t("details")} {this.state.open ? "−" : "+"}
            </button>
            {this.state.open && (
              <dl className="verified-identity__details">
                {details.map(([key, value]) => (
                  <React.Fragment key={key}>
                    <dt>{t(key)}</dt>
                    <dd>{value}</dd>
                  </React.Fragment>
                ))}
              </dl>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}
